import { haversineMeters } from './distance-meters';

export type ClusterPinMember = {
  deviceId: number;
  lat: number;
  lng: number;
};

export type ClusterPinPose = {
  deviceId: number;
  lat: number;
  lng: number;
};

/**
 * Live count-pin pose: geometric medoid (min sum of distances to others).
 * count=1 → that member. Tie → smaller deviceId.
 */
export function clusterPinPose(
  members: readonly ClusterPinMember[],
): ClusterPinPose | null {
  const valid = members.filter(
    (m) =>
      Number.isFinite(m.lat) &&
      Number.isFinite(m.lng) &&
      Number.isFinite(m.deviceId) &&
      m.deviceId > 0,
  );
  if (valid.length === 0) return null;
  if (valid.length === 1) {
    const only = valid[0]!;
    return { deviceId: only.deviceId, lat: only.lat, lng: only.lng };
  }

  let best = valid[0]!;
  let bestSum = Number.POSITIVE_INFINITY;
  for (const candidate of valid) {
    let sum = 0;
    for (const other of valid) {
      if (other.deviceId === candidate.deviceId) continue;
      sum += haversineMeters(
        { lat: candidate.lat, lng: candidate.lng },
        { lat: other.lat, lng: other.lng },
      );
    }
    if (
      sum < bestSum ||
      (sum === bestSum && candidate.deviceId < best.deviceId)
    ) {
      best = candidate;
      bestSum = sum;
    }
  }
  return { deviceId: best.deviceId, lat: best.lat, lng: best.lng };
}
